import {Icon, type IconName} from '@wandb/weave/components/Icon';
import {clsx} from 'clsx';
import React from 'react';

import {copyWithToast} from '../util/copyWithToast';

interface CopyableTextProps {
  className?: string;
  dataTest?: string;
  text: string;
  copyText?: string;
  toastText: string;
  icon?: IconName;
  code?: boolean;
  disabled?: boolean;
  onClick?(): void;
}

const CopyableText: React.FC<CopyableTextProps> = ({
  className,
  dataTest,
  text,
  copyText,
  toastText,
  icon,
  code,
  disabled,
  onClick,
}) => {
  return (
    <span
      className={clsx('copyable-text', className, {code, disabled})}
      data-test={dataTest}
      onClick={e => {
        e.stopPropagation();
        if (disabled) {
          return;
        }
        copyWithToast(copyText ?? text, toastText);
        onClick?.();
      }}>
      <span className="copyable-text-content">{text}</span>
      <Icon className="copy-icon" name={icon ?? 'copy'} />
    </span>
  );
};
CopyableText.displayName = 'CopyableText';

export default CopyableText;
